import {TranslationObject} from '@colonist/i18n'
import {LobbyImage} from '@colonist/types'
import {createDivIn, createImgIn, createParagraphIn} from '../../ui_utils/DomUtils'

export type BadgeColorClass = 'mm-badge-yellow' | 'mm-badge-green' | 'mm-badge-orange'

export interface BadgeData {
    text: TranslationObject
    icon: LobbyImage
    backgroundColorClass?: BadgeColorClass
    placement?: 'top-right' | 'bottom-row'
}

export class UIProgressBadgeElement {
    private readonly container: HTMLDivElement
    private currentData: BadgeData | undefined

    constructor(parent: HTMLElement, initialData?: BadgeData) {
        const placement = initialData?.placement ?? 'top-right'
        const className = placement === 'bottom-row' ? 'mm-mode-card-status-badge' : 'mm-mode-card-progress'
        this.container = createDivIn(parent, className)
        if(initialData != undefined) this.update(initialData)
    }

    update(data: BadgeData) {
        this.currentData = data
        this.render()
    }

    private render() {
        if(this.currentData == undefined) return

        this.container.replaceChildren()
        const placement = this.currentData.placement ?? 'top-right'
        this.container.className = placement === 'bottom-row' ? 'mm-mode-card-status-badge' : 'mm-mode-card-progress'

        if(this.currentData.backgroundColorClass != undefined) this.container.classList.add(this.currentData.backgroundColorClass)

        createImgIn(this.container, this.currentData.icon)
        createParagraphIn(this.container, this.currentData.text, '')
    }
}

